import { render, staticRenderFns } from "./tel-config.vue?vue&type=template&id=08e36f43&"
import script from "./tel-config.vue?vue&type=script&lang=js&"
export * from "./tel-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports